// PDA derivations for the forum program. Must agree exactly with
// `chain/tests/forum.ts`, which derives the same addresses against a real
// validator — if these differ, these are wrong, not the test.
import { Buffer } from 'buffer'
import { PublicKey } from '@solana/web3.js'
import { deriveAddress, u16le } from '../kit/index.js'
import { FORUM_PROGRAM_ID } from './program.js'

export function publisherPda(authority: PublicKey): PublicKey {
  return deriveAddress(['publisher', authority], FORUM_PROGRAM_ID)
}

export function videoPda(publisherPda: PublicKey, videoIdBytes: Buffer): PublicKey {
  return deriveAddress(['video', publisherPda, videoIdBytes], FORUM_PROGRAM_ID)
}

export function subtitlePda(videoPda: PublicKey, langBytes: number[]): PublicKey {
  return deriveAddress(['subtitle', videoPda, Buffer.from(langBytes)], FORUM_PROGRAM_ID)
}

export function storagePda(videoPda: PublicKey, index: number): PublicKey {
  return deriveAddress(['storage', videoPda, u16le(index)], FORUM_PROGRAM_ID)
}

export function containerPda(publisherPda: PublicKey, containerIdBytes: Uint8Array): PublicKey {
  return deriveAddress(['container', publisherPda, containerIdBytes], FORUM_PROGRAM_ID)
}

export function versionRefPda(containerPda: PublicKey, index: number): PublicKey {
  return deriveAddress(['version', containerPda, u16le(index)], FORUM_PROGRAM_ID)
}

/** One address per (container, video). The program creates it during
 * append_version, and `init` refuses an address already in use — so this is
 * what makes appending the same video to one container twice impossible.
 * Nothing reads the account; only its existence matters. */
export function versionClaimPda(containerPda: PublicKey, videoIdBytes: Uint8Array): PublicKey {
  return deriveAddress(['version_of', containerPda, videoIdBytes], FORUM_PROGRAM_ID)
}
